export const ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK =
	'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
